/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/expenses'

export interface ExpensePayload {
  expenseName: string
  expenseDescription: string
  expenseAmount: number
}

const ExpenseEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchExpenses: builder.query<any, any>({
      query: (params) => ({
        url: `${basePath}`,
        params,
      }),
      providesTags: ['expenses']
    }),

    createExpense: builder.mutation<any, ExpensePayload>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['expenses']
    }),

    deleteExpense: builder.mutation<any, string>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['expenses']
    }),

    updateExpense: builder.mutation<any, any>({
       query: ({id, body}) => ({
        url: `${basePath}/${id}`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['expenses']
    }),

    fetchExpenseReport: builder.query<any, any>({
      query: (params) => ({
        url: `${basePath}/report`,
        params,
      }),
    }),

  })

export default ExpenseEndpoints
